import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from "vue";
import ApprovalTableBase, { HeaderType } from "./ApprovalTableBase.vue";
import { ApprovalEarlytimeResponse } from "@/models/approval/ApprovalResponse";
import { ApprovalSearchRequest } from "@/models/approval/ApprovalRequest";
import { Authority } from "@/models/enum/Enum";
import { Paths } from "@/plugins/api/paths";
import { $post } from "@/plugins/api/api";
import { $confirm } from "@/plugins/confirm/confirm";
import { $alert } from "@/plugins/alert/alert";
import { useApproval } from "@/composable/Approval";
import EarlytimeDialog from "../form/EarlytimeDialog.vue";
import EarlytimeExpandItem from "../expand/EarlytimeExpandItem.vue";
import Vuex from "@/store/index";


export default /*#__PURE__*/_defineComponent({
  __name: 'EarlytimeTable',
  setup(__props) {

const approval = useApproval();

const header: HeaderType = {
  key: "recordId",
  date: "earlytimeWorkDate",
  user: "employeeName",
  affiliation: "affiliationName",
  approval: "approvalState"
};

const title = "早出申請承認";

const selected = ref<ApprovalEarlytimeResponse[]>([]);
const items = ref<ApprovalEarlytimeResponse[]>([]);
const form = ref<ApprovalSearchRequest>(approval.getForm());

const isDisabled = computed(() => {
  const authority = Vuex.state.authority;
  return authority < Authority.Manager;
});

const getItems = async (request: ApprovalSearchRequest) => {
  const response = await $post<ApprovalEarlytimeResponse[]>(
    Paths.approval.earlytime.search,
    request
  );
  if (response) items.value = response;
};

const onSearch = async () => {
  await getItems(form.value);
};

const onResolve = async (
  items: ApprovalEarlytimeResponse[],
  selected: ApprovalEarlytimeResponse[]
) => {
  const message = `${items.length}件承認します。\nよろしいですか？`;
  if (!(await $confirm(message))) return;

  const result = await $post(Paths.approval.earlytime.resolve, items);
  if (result) $alert("success", `${result}件承認しました。`);
  await onSearch();

  console.log("selected", selected);
  selected = [];
};

const onReject = async (
  items: ApprovalEarlytimeResponse[],
  selected: ApprovalEarlytimeResponse[]
) => {
  const message = `${items.length}件却下します。\nよろしいですか？`;
  if (!(await $confirm(message))) return;

  const result = await $post(Paths.approval.earlytime.reject, items);
  if (result) $alert("success", `${result}件却下しました。`);
  await onSearch();

  console.log("selected", selected);
  selected = [];
};

const onCancel = async (
  item: ApprovalEarlytimeResponse,
  selected: ApprovalEarlytimeResponse[]
) => {
  const message = "承認を取り消します。\nよろしいですか？";
  if (!(await $confirm(message))) return;

  const result = await $post(
    `${Paths.approval.earlytime.cancel}/${item.recordId}`
  );
  if (result) {
    $alert("success", "取消に成功しました。");
    await onSearch();

    console.log("selected", selected);
    selected = [];
  }
};

onMounted(async () => {
  await onSearch();
});

return { __sfc: true,approval, header, title, selected, items, form, isDisabled, getItems, onSearch, onResolve, onReject, onCancel, ApprovalTableBase, EarlytimeDialog, EarlytimeExpandItem }
}

})